<template>
  <ul class="chat-body-container">
    <template
      v-for="(message, index) in chatMessages">

      <chat-message-divider v-if="dateDividerIndexes.has(index)" :key="message.id + '-divider'" :timestamp="message.timeStamp" />
      <chat-message :key="message.id" :chatMessageDto="message" />

    </template>
  </ul>
</template>

<script>
import moment from 'moment';
import InfiniteScrollObserver from '@/lib/infinite-scroll-observer';
import {mapState, mapGetters, mapActions} from 'vuex';
import ChatMessage from './ChatMessage';
import ChatMessageDivider from './ChatMessageDivider';

export default {
  components: {
    'chat-message': ChatMessage,
    'chat-message-divider': ChatMessageDivider
  },

  date() {
    return {
      dividerTimes: []
    };
  },

  computed: {
    ...mapGetters('chat', {
      chatMessages: 'chatMessages'
    }),

    ...mapState('chat', {
      chatId: state => state.currentChat.id
    }),

    dateDividerIndexes() {
      let set = new Set();
      if (this.chatMessages.length === 0) {
        return set;
      }
      let lastDividerTime = moment(this.chatMessages[0].timeStamp).subtract(1, 'day');
      for (let i = 0; i < this.chatMessages.length; i++) {
        let time = moment(this.chatMessages[i].timeStamp);
        let isCrossDay = lastDividerTime.diff(time, 'days') !== 0;
        if (isCrossDay) {
          time.hour(0).minute(0).second(0).millisecond(0);
          lastDividerTime = time;
          set.add(i);
        }
      }

      return set;
    }
  },

  watch: {
    async chatId() {
      this._infiniteScrollObserver.unobserve();
      await this.$nextTick();
      this._infiniteScrollObserver.observe(this.$el);
    }
  },

  mounted() {
    this.$eventBus.$on('chat-message-height-expand', this.onMessageHeightExpand);

    this._infiniteScrollObserver = new InfiniteScrollObserver(this.retriveMessages.bind(this));
    this._infiniteScrollObserver.observe(this.$el);
  },

  beforeDestroy() {
    this.$eventBus.$off('chat-message-height-expand', this.onMessageHeightExpand);
    this._infiniteScrollObserver.unobserve();
  },

  methods: {
    ...mapActions('chat', {
      retrievePreviousMessages: 'retrievePreviousMessages'
    }),

    stickScrollbarToBottom() {
      this._infiniteScrollObserver.stickToEnd = true;
    },

    retriveMessages() {
      let chatMessageDto = this.chatMessages[0];
      this.retrievePreviousMessages({refChatMessageDto: chatMessageDto});
    },

    onMessageHeightExpand(expandHeight) {
      if (this._infiniteScrollObserver.isScrollEnd) {
        this.$el.scrollTop += expandHeight;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.chat-body-container {
  position: relative;
  padding: 1rem;
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
</style>
